// import axios from 'axios'
import buildType from '../../../services/buildType'
// import router from '../../../router/index'
export default {
  state: {
    urlQuery: null,
    esanqua: buildType.apiURL('esanqua'),
    selectedInvoiceList: null,
    invoiceQueueIndex: 0
  },
  mutations: {
    setInvoicePageQuery(state, payload) {
      state.urlQuery = payload
    },
    setInvoiceQueue(state, payload) {
      state.selectedInvoiceList = payload.list
      state.invoiceQueueIndex = payload.index
    }
  },
  actions: {},
  getters: {
    getInvoicePageQuery(state) {
      return state.urlQuery
    },
    getInvoiceList(state) {
      return {
        list: state.selectedInvoiceList,
        index: state.invoiceQueueIndex
      }
    }
  }
}
